<!-- Authored.by.KWShin.2024.03.28. -->
<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    title() {
      return this.$t('dv.title.tqi');
    },
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  methods: {
    setData(dataList) {
      if (dataList.length > 0) {
        this.data.value = dataList.length;
      } else this.data.value = 0;
    },
  },
};
</script>
